import { useQuery } from "@tanstack/react-query";
import { useAppService } from "../../use-app-service";
import { storefrontKeys } from "../query-keys";

export const useGetStorefrontConfigAllocations = (nomPurchaserId: string) => {
  const service = useAppService();
  return useQuery({
    queryKey: [storefrontKeys.configs(nomPurchaserId)],
    queryFn: () =>
      service.orgGetStoreAllocationsForNomPurchaser(nomPurchaserId),
  });
};
